<!-- 报价详情弹框 -->
<template>
    <el-dialog
        class="el-dialog2 hiddenScrollbar"
        style="margin-right: 50%; width: 760px;overflow-y: inherit;margin-left: 0.6rem;margin-top: 0 !important;top: 45% !important;transform: translateY(-50%);height: 910px;"
        :append-to-body="true"
        :modal="false"
        :visible.sync="dialogVisible"
        :destroy-on-close="true"
        @close="close"
        width="80%"
    >
        <div style="position: sticky;bottom: 20px" v-if="showButton">
            <el-button type="primary" size="mini" @click="emitSave">立即保存</el-button>
            <el-button size="mini" @click="dialogVisible=false">取 消</el-button>
        </div>
        <div class="lineBox hiddenScrollbar" style="overflow-y: scroll;position: relative;height: 910px"
             :style="{height: getHeight}">
            <!--        <div v-for="(item, index) in previewDatas" :key="index">-->
            <!--          <p class="p1">{{ item.budgetTitle }}:</p>-->
            <!--          <p class="p2">{{ item.budgetTitleContent }}</p>-->
            <!--        </div>-->
            <!--          <Ueditor style="height:80vh;" v-if="dialogVisible" class="myUeditor" ref="ueditor" :readonly="readonly" :bar="bars" :autoSyncData="false" :enableContextMenu="false"></Ueditor>-->
            <Tinymce v-model="datas" :display-mode="displayMode" :height="700" style="margin-top: 10px" :key="brush"></Tinymce>
        </div>

    </el-dialog>
</template>

<script>
import Ueditor from "@/components/Editor/Ueditor.vue";
import Tinymce from "@/components/Tinymce.vue";

export default {
    components: {Ueditor, Tinymce},
    data() {
        return {
            brush: 1,
            datas: "",
            getHeight: '0px',
            dialogVisible: false,
            previewDatas: [], //渲染的数据
        }
    },
    computed: {},
    watch: {},
    props: {
        showButton: {
            type: Boolean,
            default: () => {
                return true
            }
        },
        displayMode: {
            type: Boolean,
            default: () => {
                return false
            }
        }
    },
    methods: {
        emitSave() {
            this.$emit("emitSave",this.datas)
        },
        init(datas) {
            this.dialogVisible = true
            this.$nextTick(() => {
                // console.log("setUeContent", datas)
                // this.$refs.ueditor.setUeContent(datas)
                this.$set(this,"datas",datas)
                this.$forceUpdate()
                this.brush++
            })
            // this.previewDatas = datas
        },
        dataUpdate(v) {
            this.$nextTick(() => {
                this.$refs.ueditor.setUeContent(v)
            })
        },
        close() {
            this.dialogVisible = false
        }
    },
    created() {

    },
    mounted() {
        this.getHeight = document.body.clientHeight - 200 + 'px'
    },
}
</script>
<style lang='scss' scoped>
/deep/ .el-dialog {
    border-radius: 0.25rem;

    .el-dialog__body {
        padding-bottom: 20px;
        padding-top: 10px !important;
    }
}

/deep/ .el-dialog2 .el-dialog__headerbtn {
    top: 0.1rem !important;
}

/deep/ .el-dialog__body {
    height: 90vh !important;
}

.el-dialog2 {
    /deep/ .el-dialog {
        margin-top: 1rem !important;
    }

    position: fixed;
    //z-index: 3100 !important;
    z-index: 3000 !important;

    .lineBox {
        .myUeditor {
            top: 4px;

            /deep/ .edui-editor-toolbarbox {
                display: none;
            }

            /deep/ .edui-editor {
                border: none;
            }

            /deep/ .edui-editor-bottomContainer {
                display: none;
            }
        }

        p {
            margin-bottom: 0.02rem;
        }

        .p1 {
            font-size: 0.2rem;
            color: #285ca2;
            font-weight: 700;
        }

        .p2 {
            white-space: pre-line
        }
    }
}
</style>
